import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ValidatedField from 'components/controls/validated-field';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { translationApi  } from 'actions/translation-api';
import { changeSearchCriteria, changeClient } from 'store/client/slice.facility-list-filter';
import { tryParseInt } from 'utils/number-utils';

const ClientFacilitySearchFilter = () => {
    const dispatch = useDispatch();
    const params = useParams();
	const clientIdString = params.id;
	const clientId = tryParseInt(clientIdString);
    const clientPreSelected = clientId !== null;

    const [submitEnabled, setSubmitEnabled] = useState(true);
	const facilityListFilter = useSelector(state => state.facilityListFilter);
    const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const filterForCurrentClient = (isNaN(clientId) && isNaN(facilityListFilter.filterForClient)) || clientId === facilityListFilter.filterForClient;
	if (!filterForCurrentClient) {
		dispatch(changeClient(clientId));
	}

    const handleSubmit = fields => {
        const filter = {
            clientId: tryParseInt(fields?.clientId),
            clientName: fields?.clientName,
            clientVatin: fields?.clientVatin,
            clientFacilityName: fields?.clientFacilityName,
            page: 1,
        };
        dispatch(changeSearchCriteria(filter));

        setSubmitEnabled(false);
        setTimeout(() => setSubmitEnabled(true), 1000);
    };

    const validationSchema = Yup.object().shape({
        clientId: Yup.number(),
        clientName: Yup.string(),
        clientVatin: Yup.string()
            .max(10, translations.warningValueTooLong),
        clientFacilityName: Yup.string()
    });
    
    const initialValues = {
        clientId: filterForCurrentClient ? facilityListFilter?.clientId?.toString().padStart(4, '0') ?? "" : clientPreSelected ? clientId : "",
        clientName: filterForCurrentClient ? facilityListFilter?.clientName ?? "" : "",
        clientVatin: filterForCurrentClient ? facilityListFilter?.clientVatin ?? "" : "",
        clientFacilityName: filterForCurrentClient ? facilityListFilter?.clientFacilityName ?? "" : ""
    };

    const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={fields => { handleSubmit(fields) }}>
            {props => (
                <Form autoComplete={randomAutoComplete}>
                    <div className="col-12 mb-4">
                        <div className="card border-light shadow-sm">
                            <div className="card-body">
                                <h2 className="h6 mb-2">{translations.filters}</h2>
                                <div className="row">
                                    {clientPreSelected &&
                                        <Field name="clientId" type="hidden" />
                                    }
                                    {!clientPreSelected &&
                                        <div className="col-lg-1 col-md-12 mb-2">
                                            <ValidatedField name="clientId" placeholder={translations.clientNumberShort} maxLength="4" {...props} />
                                        </div>
                                    }
                                    {!clientPreSelected &&
                                        <div className="col-lg-2 col-md-12 mb-2">
                                            <ValidatedField name="clientName" placeholder={translations.clientName} {...props} />
                                        </div>
                                    }
                                    {!clientPreSelected &&
                                        <div className="col-lg-2 col-md-12 mb-2">
                                            <ValidatedField name="clientVatin" placeholder={translations.clientVATIN} maxLength="10" {...props} />
                                        </div>
                                    }
                                    <div className="col-lg-2 col-md-12 mb-2">
                                        <ValidatedField name="clientFacilityName" placeholder={translations.clientFacilityName} {...props} />
                                    </div>
                                    <div className="col mb-2">
                                        <button id="searchButton" type="submit" className="btn btn-secondary float-end" disabled={submitEnabled ? null : 'disabled'} ><FontAwesomeIcon icon={faSearch} className="me-2" />{translations.actionSearch}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>)}
        </Formik>
    )
}

export default ClientFacilitySearchFilter;
